import React from "react";

function Steps({ stepNum, setFormNum }) {
  const handleStepClick = (clickedStep) => {
    // if (clickedStep <= stepNum) {
      
    // }
    setFormNum(clickedStep);
  };

  return (
    <div className="flex items-center space-x-4 mb-4">
      {[1, 2, 3, 4].map((step) => (
        <React.Fragment key={step}>
          <button
            type="button"
            onClick={() => handleStepClick(step)}
            className={`w-8 h-8 flex items-center justify-center rounded-full ${
              stepNum === step
                ? "ring-[#006A4E] text-black ring-2"
                : "ring-[#CAD0D9] text-black ring-2"
            }`}
          >
            {step}
          </button>
          {step < 4 && (
            <div className="flex-grow border-t border-gray-600"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default Steps;